export default {
  GET_SHIFTLOG:'GET_SHIFTLOG',
  UPDATE_SHIFTLOG:'UPDATE_SHIFTLOG',
  ADD_TEAMSHIFTLOG:'ADD_TEAMSHIFTLOG',
  GET_SHIFTLOGS: 'GET_SHIFTLOGS',
  LOADINGINPROGRESS:'LOADINGINPROGRESS',
  UPDATE_TEAM_SHIFTLOG:'UPDATE_TEAM_SHIFTLOG',
  GET_TEAMSHIFTLOGS:'GET_TEAMSHIFTLOGS',
  GET_TEAMSHIFTLOG:'GET_TEAMSHIFTLOG',
  GET_PREFERENCE:'GET_PREFERENCE'
}